<template>
  <div class="row bg-white accesory-box">
    <div class="col form-group d-flex align-items-center mb-2">
      <span class="w-100">
        <h3 class="h5 mt-3 fw-bold">{{ name }}</h3>
        <button
          type="button"
          v-if="selectable"
          class="info border border-white me-2"
          :id="`${aKey}-tooltip`"
          data-toggle="tooltip"
          data-placement="right"
        >
          ?
        </button>
        <small>
          <span v-if="typeof insurancePrice == 'string'">{{ insurancePrice }}</span>
          <span v-else-if="insurancePrice === -1">Nem nyújtunk rá fedezetet</span>
          <span v-else-if="typeof insurancePrice == 'number' && insurancePrice"
            >biztosítási összeg: {{ insurancePrice | currency }}</span
          >
          <span v-if="customEnding">{{ customEnding }}</span>
        </small>
      </span>
    </div>
    <div class="col-sm-3 d-flex align-items-center" v-if="insuranceFee">
      <span v-if="typeof insuranceFee == 'number'">
        <b>+{{ insuranceFee | currency }}</b> /év
      </span>
      <span v-else v-html="insuranceFee"> </span>
    </div>
    <div
      class="col-sm-3 d-flex align-items-center justify-content-sm-end my-3"
      v-if="insurancePrice !== -1 && selectable"
    >
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input dark-border"
          :id="aKey"
          :name="`${aKey}[]`"
          :value="1"
          v-model="selected"
          @click="clickOn($event)"
        />
        <label :for="aKey" class="form-check-label">Kérem</label>
      </div>
    </div>
    <div
      class="col-12 mb-2"
      v-if="['ertektargy', 'baleset', 'utasbiztositas'].includes(aKey) && selected"
    >
      <div v-if="aKey == 'ertektargy'">
        <ValidationProvider :immediate="true" rules="valuables_above_200_max" v-slot="{errors}">
          <input type="text" :value="valuesAbove200Sum" disabled hidden />
          <div class="text-danger mb-3">{{ errors[0] }}</div>
        </ValidationProvider>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="nemesfemek">Nemesfémek, ékszerek, drágakövek</label>
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="nemesfemek"
                name="ekszerek"
                aria-describedby="nemesfemek-prepend"
                :class="classes"
                v-model="jewelryPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="nemesfemek-prepend">Ft</span>
              </div>
            </div>
            <small id="nemesfemek-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ jewelryPrice | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="antiktargyak"
            >Antik bútorok és antik tárgyak, képzőművészeti alkotások</label
          >
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="antiktargyak"
                name="antik_butorok"
                aria-describedby="antiktargyak-prepend"
                :class="classes"
                v-model="antiquesPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="antiktargyak-prepend">Ft</span>
              </div>
            </div>
            <small id="antiktargyak-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ antiquesPrice | currency }}</div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="kulonleges_textiliak"
            >Valódi szőrmék, kézicsomózású szőnyegek, különleges textíliák</label
          >
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="kulonleges_textiliak"
                name="szormek"
                aria-describedby="kulonleges_textiliak-prepend"
                :class="classes"
                v-model="exoticTextilePrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="kulonleges_textiliak-prepend">Ft</span>
              </div>
            </div>
            <small id="kulonleges_textiliak-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ exoticTextilePrice | currency }}</div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="gyujtemeny">Gyűjtemény</label>
          <ValidationProvider
            rules="required|currency_min:0"
            v-slot="{errors, classes}"
            class="col-sm-8"
            v-if="selectable"
          >
            <div class="input-group">
              <input
                v-currency="{valueRange: {min: 0}}"
                class="form-control dark-border"
                id="gyujtemeny"
                name="gyujtemeny"
                aria-describedby="gyujtemeny-prepend"
                :class="classes"
                v-model="collectionPrice"
              />
              <div class="input-group-append d-block dark-border">
                <span class="input-group-text" id="gyujtemeny-prepend">Ft</span>
              </div>
            </div>
            <small id="gyujtemeny-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-sm-8" v-else>{{ collectionPrice | currency }}</div>
        </div>
      </div>
      <div v-else-if="aKey == 'baleset'">
        <div class="form-group row">
          <label class="col-sm-4">Típusa</label>
          <div class="col-sm-8" v-if="selectable">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="balesetbiztositas_tipusa"
                id="baleset_bizt_standard"
                :value="'standard'"
                v-model="accidentInsuranceType"
              />
              <label class="form-check-label" for="baleset_bizt_standard">
                Standard (5 000 Ft)
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="balesetbiztositas_tipusa"
                id="baleset_bizt_medium"
                :value="'medium'"
                v-model="accidentInsuranceType"
              />
              <label class="form-check-label" for="baleset_bizt_medium">
                Médium (10 000 Ft)
              </label>
            </div>
            <small id="balesetbiztositas_tipusa-error" class="text-danger input-alert"></small>
          </div>
          <div class="col-sm-8" v-else>
            <span v-if="accidentInsuranceType === 'standard'">Standard (5 000 Ft)</span>
            <span v-else>Médium (10 000 Ft)</span>
          </div>
        </div>
      </div>
      <div v-else-if="aKey == 'utasbiztositas'">
        <div class="form-group row" v-if="selectable" :class="{'mb-5': insuredPersons.length > 0}">
          <label class="col-sm-4" for="utasbiztositottak_szama">
            Utasbiztosítottak száma<br /><br />
            Ha 2 fő részére szeretne utasbiztosítást kötni kérjük, 2 főt adjon hozzá abban az
            esetben is, ha az egyik biztosított adatai megegyeznek a az Ön (Szerződő) adataival.
          </label>
          <div class="col-sm-4 col-md-6 mb-4">
            <input
              class="form-control"
              type="number"
              readonly
              :value="insuredPersons.length"
              id="utasbiztositottak_szama"
              name="utasbiztositottak_szama"
            />
          </div>
          <div class="col-sm-4 col-md-2">
            <div class="btn btn-outline-danger w-100" @click="addInsuredPerson">Hozzáadás</div>
          </div>
        </div>
        <div v-for="(person, key) in insuredPersons" :key="key">
          <h2 v-if="insuredPersons.length > 1" class="mt-5">
            {{ key + 1 }}. utasbiztosított adatai
          </h2>
          <InsuredPerson :person="person" :pKey="key" :selectable="selectable" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {parse} from 'vue-currency-input';
import {mapFields} from 'vuex-map-fields';
import InsuredPerson from './InsuredPerson';

export default {
  props: ['accesory', 'aKey', 'selectable'],
  components: {InsuredPerson},
  computed: {
    selected: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].selected;
      },
      set(value) {
        this.$store.commit('updateAccesory', {key: this.aKey, value: value});
      },
    },
    name: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].name;
      },
    },
    insurancePrice: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].insurancePrice;
      },
    },
    insuranceFee: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].insuranceFee;
      },
    },
    customEnding: {
      get() {
        return this.$store.state.chooseableAccesories.selectableList[this.aKey].customEnding;
      },
    },
    ...mapFields([
      'chooseableAccesories.valuablesAbove200',
      'chooseableAccesories.valuablesAboveInputs',
      'chooseableAccesories.valuesAbove200Sum',
      'chooseableAccesories.valuesAbove200Minimum',
      'chooseableAccesories.valuesAbove200Maximum',
      'chooseableAccesories.accidentInsuranceType',
    ]),
    ...mapFields({
      jewelryPrice: 'chooseableAccesories.valuablesAboveInputs.jewelry',
      antiquesPrice: 'chooseableAccesories.valuablesAboveInputs.antiques',
      exoticTextilePrice: 'chooseableAccesories.valuablesAboveInputs.exotic',
      collectionPrice: 'chooseableAccesories.valuablesAboveInputs.collection',
      accesoriesList: 'chooseableAccesories.selectableList',
      insuredPersonTemplate: 'chooseableAccesories.travelInsuranced.template',
      insuredPersons: 'chooseableAccesories.travelInsuranced.list',
    }),
  },
  watch: {
    valuablesAboveInputs: {
      deep: true,

      handler(data) {
        this.calculateSumPrice(data);
      },
    },
  },
  methods: {
    clickOn(e) {
      if (e && this.selected) e.preventDefault();
      if (this.selected) {
        Swal.fire({
          title: 'Biztos, hogy el akarja távolítani?',
          text:
            'Gondolja meg, mert egy esetleges kár esetén valóban hasznos kiegészítő lehet ez a biztosítási fedezet.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Igen, eltávolítom',
          cancelButtonText: 'Megtartom',
          confirmButtonColor: '#E4002C',
        }).then((result) => {
          if (result.value) this.selected = false;
        });
      }
    },
    calculateSumPrice(data) {
      let price = 0;
      for (const [key, value] of Object.entries(data)) {
        if (typeof value == 'string') {
          const parsedInt = parse(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }

      this.valuesAbove200Sum = price;
    },
    addInsuredPerson() {
      if (this.insuredPersons.length < 10)
        this.$store.commit('addInsuredPerson', Object.assign({}, this.insuredPersonTemplate));
    },
  },
};
</script>

<style lang="scss">
.accesory-box {
  border-radius: 0.25rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;

  h3 {
    word-break: normal;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}
</style>
